import { setDataset } from './dataset.js';
import { setStyles } from './style.js';

/**
 * Represents the parameters for creating a div element.
 */
export interface DivElementParameters {
    /** Optional: The ID of the div element. */
    id?: string;
    /** Optional: The list of CSS classes for the div element. */
    classList?: string[];
    /** Optional: some styles to set */
    styles?: Partial<CSSStyleDeclaration>;
    dataset?: Record<string, string>;
}

/**
 * Creates a HTMLDivElement with the specified parameters.
 *
 * @param param The parameters for creating the div element.
 * @returns The created div element.
 */
export const createDivElement = ({ id, classList = [], styles = {}, dataset = {} }: DivElementParameters): HTMLDivElement => {
    const element = document.createElement('div');
    // set the ID of the div element if provided
    if (id) element.id = id;
    // add each CSS class to the div element's class list.
    for (const className of classList) {
        element.classList.add(className);
    }
    setStyles(element, styles);
    setDataset(element, dataset);
    return element;
};
